export default __webpack_public_path__ + "img/4b22c77d26938116978caf07dc02f25a.png";